// source: protos/stores/stores.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var protos_shared_money_pb = require('../../protos/shared/money_pb.js');
goog.object.extend(proto, protos_shared_money_pb);
goog.exportSymbol('proto.trendhim.service.stores.GetStoreRequest', null, global);
goog.exportSymbol('proto.trendhim.service.stores.ListStoresRequest', null, global);
goog.exportSymbol('proto.trendhim.service.stores.ListStoresResponse', null, global);
goog.exportSymbol('proto.trendhim.service.stores.Store', null, global);
goog.exportSymbol('proto.trendhim.service.stores.StoreConfig', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.trendhim.service.stores.StoreConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.trendhim.service.stores.StoreConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.trendhim.service.stores.StoreConfig.displayName = 'proto.trendhim.service.stores.StoreConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.trendhim.service.stores.Store = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.trendhim.service.stores.Store, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.trendhim.service.stores.Store.displayName = 'proto.trendhim.service.stores.Store';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.trendhim.service.stores.ListStoresRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.trendhim.service.stores.ListStoresRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.trendhim.service.stores.ListStoresRequest.displayName = 'proto.trendhim.service.stores.ListStoresRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.trendhim.service.stores.ListStoresResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.trendhim.service.stores.ListStoresResponse.repeatedFields_, null);
};
goog.inherits(proto.trendhim.service.stores.ListStoresResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.trendhim.service.stores.ListStoresResponse.displayName = 'proto.trendhim.service.stores.ListStoresResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.trendhim.service.stores.GetStoreRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.trendhim.service.stores.GetStoreRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.trendhim.service.stores.GetStoreRequest.displayName = 'proto.trendhim.service.stores.GetStoreRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.trendhim.service.stores.StoreConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.trendhim.service.stores.StoreConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.trendhim.service.stores.StoreConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.StoreConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    countryCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    localeCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    urlDomain: jspb.Message.getFieldWithDefault(msg, 4, ""),
    urlPath: jspb.Message.getFieldWithDefault(msg, 5, ""),
    urlFull: jspb.Message.getFieldWithDefault(msg, 6, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 7, ""),
    email: jspb.Message.getFieldWithDefault(msg, 8, ""),
    vatNumber: jspb.Message.getFieldWithDefault(msg, 9, ""),
    merchantAccount: jspb.Message.getFieldWithDefault(msg, 10, ""),
    cheapestShippingPrice: (f = msg.getCheapestShippingPrice()) && protos_shared_money_pb.Money.toObject(includeInstance, f),
    freeShippingThreshold: (f = msg.getFreeShippingThreshold()) && protos_shared_money_pb.Money.toObject(includeInstance, f),
    adwordsCurrencyRatesMap: (f = msg.getAdwordsCurrencyRatesMap()) ? f.toObject(includeInstance, undefined) : [],
    adwordsTrackingId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    trustpilotBusinessId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    trustpilotDomain: jspb.Message.getFieldWithDefault(msg, 16, ""),
    analyticsTrackingId: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.trendhim.service.stores.StoreConfig}
 */
proto.trendhim.service.stores.StoreConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.trendhim.service.stores.StoreConfig;
  return proto.trendhim.service.stores.StoreConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.trendhim.service.stores.StoreConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.trendhim.service.stores.StoreConfig}
 */
proto.trendhim.service.stores.StoreConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocaleCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrlDomain(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrlPath(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrlFull(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setVatNumber(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantAccount(value);
      break;
    case 11:
      var value = new protos_shared_money_pb.Money;
      reader.readMessage(value,protos_shared_money_pb.Money.deserializeBinaryFromReader);
      msg.setCheapestShippingPrice(value);
      break;
    case 12:
      var value = new protos_shared_money_pb.Money;
      reader.readMessage(value,protos_shared_money_pb.Money.deserializeBinaryFromReader);
      msg.setFreeShippingThreshold(value);
      break;
    case 13:
      var value = msg.getAdwordsCurrencyRatesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readDouble, null, "", 0.0);
         });
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdwordsTrackingId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrustpilotBusinessId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrustpilotDomain(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnalyticsTrackingId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.trendhim.service.stores.StoreConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.trendhim.service.stores.StoreConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.trendhim.service.stores.StoreConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.StoreConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocaleCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrlDomain();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrlPath();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUrlFull();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getVatNumber();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMerchantAccount();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCheapestShippingPrice();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      protos_shared_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getFreeShippingThreshold();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      protos_shared_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getAdwordsCurrencyRatesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(13, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeDouble);
  }
  f = message.getAdwordsTrackingId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTrustpilotBusinessId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getTrustpilotDomain();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAnalyticsTrackingId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional string country_code = 1;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string locale_code = 2;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getLocaleCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setLocaleCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string currency_code = 3;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string url_domain = 4;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getUrlDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setUrlDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string url_path = 5;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getUrlPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setUrlPath = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string url_full = 6;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getUrlFull = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setUrlFull = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string phone = 7;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string email = 8;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string vat_number = 9;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getVatNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setVatNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string merchant_account = 10;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getMerchantAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setMerchantAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional trendhim.shared.Money cheapest_shipping_price = 11;
 * @return {?proto.trendhim.shared.Money}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getCheapestShippingPrice = function() {
  return /** @type{?proto.trendhim.shared.Money} */ (
    jspb.Message.getWrapperField(this, protos_shared_money_pb.Money, 11));
};


/**
 * @param {?proto.trendhim.shared.Money|undefined} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
*/
proto.trendhim.service.stores.StoreConfig.prototype.setCheapestShippingPrice = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.clearCheapestShippingPrice = function() {
  return this.setCheapestShippingPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.trendhim.service.stores.StoreConfig.prototype.hasCheapestShippingPrice = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional trendhim.shared.Money free_shipping_threshold = 12;
 * @return {?proto.trendhim.shared.Money}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getFreeShippingThreshold = function() {
  return /** @type{?proto.trendhim.shared.Money} */ (
    jspb.Message.getWrapperField(this, protos_shared_money_pb.Money, 12));
};


/**
 * @param {?proto.trendhim.shared.Money|undefined} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
*/
proto.trendhim.service.stores.StoreConfig.prototype.setFreeShippingThreshold = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.clearFreeShippingThreshold = function() {
  return this.setFreeShippingThreshold(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.trendhim.service.stores.StoreConfig.prototype.hasFreeShippingThreshold = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * map<string, double> adwords_currency_rates = 13;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getAdwordsCurrencyRatesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 13, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.clearAdwordsCurrencyRatesMap = function() {
  this.getAdwordsCurrencyRatesMap().clear();
  return this;};


/**
 * optional string adwords_tracking_id = 14;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getAdwordsTrackingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setAdwordsTrackingId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string trustpilot_business_id = 15;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getTrustpilotBusinessId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setTrustpilotBusinessId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string trustpilot_domain = 16;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getTrustpilotDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setTrustpilotDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string analytics_tracking_id = 17;
 * @return {string}
 */
proto.trendhim.service.stores.StoreConfig.prototype.getAnalyticsTrackingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.StoreConfig} returns this
 */
proto.trendhim.service.stores.StoreConfig.prototype.setAnalyticsTrackingId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.trendhim.service.stores.Store.prototype.toObject = function(opt_includeInstance) {
  return proto.trendhim.service.stores.Store.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.trendhim.service.stores.Store} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.Store.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mainStore: jspb.Message.getFieldWithDefault(msg, 4, ""),
    config: (f = msg.getConfig()) && proto.trendhim.service.stores.StoreConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.trendhim.service.stores.Store}
 */
proto.trendhim.service.stores.Store.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.trendhim.service.stores.Store;
  return proto.trendhim.service.stores.Store.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.trendhim.service.stores.Store} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.trendhim.service.stores.Store}
 */
proto.trendhim.service.stores.Store.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMainStore(value);
      break;
    case 3:
      var value = new proto.trendhim.service.stores.StoreConfig;
      reader.readMessage(value,proto.trendhim.service.stores.StoreConfig.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.trendhim.service.stores.Store.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.trendhim.service.stores.Store.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.trendhim.service.stores.Store} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.Store.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMainStore();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.trendhim.service.stores.StoreConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.trendhim.service.stores.Store.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.Store} returns this
 */
proto.trendhim.service.stores.Store.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.trendhim.service.stores.Store.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.Store} returns this
 */
proto.trendhim.service.stores.Store.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string main_store = 4;
 * @return {string}
 */
proto.trendhim.service.stores.Store.prototype.getMainStore = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.Store} returns this
 */
proto.trendhim.service.stores.Store.prototype.setMainStore = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional StoreConfig config = 3;
 * @return {?proto.trendhim.service.stores.StoreConfig}
 */
proto.trendhim.service.stores.Store.prototype.getConfig = function() {
  return /** @type{?proto.trendhim.service.stores.StoreConfig} */ (
    jspb.Message.getWrapperField(this, proto.trendhim.service.stores.StoreConfig, 3));
};


/**
 * @param {?proto.trendhim.service.stores.StoreConfig|undefined} value
 * @return {!proto.trendhim.service.stores.Store} returns this
*/
proto.trendhim.service.stores.Store.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.trendhim.service.stores.Store} returns this
 */
proto.trendhim.service.stores.Store.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.trendhim.service.stores.Store.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.trendhim.service.stores.ListStoresRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.trendhim.service.stores.ListStoresRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.trendhim.service.stores.ListStoresRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.ListStoresRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.trendhim.service.stores.ListStoresRequest}
 */
proto.trendhim.service.stores.ListStoresRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.trendhim.service.stores.ListStoresRequest;
  return proto.trendhim.service.stores.ListStoresRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.trendhim.service.stores.ListStoresRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.trendhim.service.stores.ListStoresRequest}
 */
proto.trendhim.service.stores.ListStoresRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.trendhim.service.stores.ListStoresRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.trendhim.service.stores.ListStoresRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.trendhim.service.stores.ListStoresRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.ListStoresRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 page_size = 1;
 * @return {number}
 */
proto.trendhim.service.stores.ListStoresRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.trendhim.service.stores.ListStoresRequest} returns this
 */
proto.trendhim.service.stores.ListStoresRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string page_token = 2;
 * @return {string}
 */
proto.trendhim.service.stores.ListStoresRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.ListStoresRequest} returns this
 */
proto.trendhim.service.stores.ListStoresRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.trendhim.service.stores.ListStoresResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.trendhim.service.stores.ListStoresResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.trendhim.service.stores.ListStoresResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.trendhim.service.stores.ListStoresResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.ListStoresResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    storesList: jspb.Message.toObjectList(msg.getStoresList(),
    proto.trendhim.service.stores.Store.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.trendhim.service.stores.ListStoresResponse}
 */
proto.trendhim.service.stores.ListStoresResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.trendhim.service.stores.ListStoresResponse;
  return proto.trendhim.service.stores.ListStoresResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.trendhim.service.stores.ListStoresResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.trendhim.service.stores.ListStoresResponse}
 */
proto.trendhim.service.stores.ListStoresResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.trendhim.service.stores.Store;
      reader.readMessage(value,proto.trendhim.service.stores.Store.deserializeBinaryFromReader);
      msg.addStores(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.trendhim.service.stores.ListStoresResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.trendhim.service.stores.ListStoresResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.trendhim.service.stores.ListStoresResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.ListStoresResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.trendhim.service.stores.Store.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated Store stores = 1;
 * @return {!Array<!proto.trendhim.service.stores.Store>}
 */
proto.trendhim.service.stores.ListStoresResponse.prototype.getStoresList = function() {
  return /** @type{!Array<!proto.trendhim.service.stores.Store>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.trendhim.service.stores.Store, 1));
};


/**
 * @param {!Array<!proto.trendhim.service.stores.Store>} value
 * @return {!proto.trendhim.service.stores.ListStoresResponse} returns this
*/
proto.trendhim.service.stores.ListStoresResponse.prototype.setStoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.trendhim.service.stores.Store=} opt_value
 * @param {number=} opt_index
 * @return {!proto.trendhim.service.stores.Store}
 */
proto.trendhim.service.stores.ListStoresResponse.prototype.addStores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.trendhim.service.stores.Store, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.trendhim.service.stores.ListStoresResponse} returns this
 */
proto.trendhim.service.stores.ListStoresResponse.prototype.clearStoresList = function() {
  return this.setStoresList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.trendhim.service.stores.ListStoresResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.ListStoresResponse} returns this
 */
proto.trendhim.service.stores.ListStoresResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.trendhim.service.stores.GetStoreRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.trendhim.service.stores.GetStoreRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.trendhim.service.stores.GetStoreRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.GetStoreRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.trendhim.service.stores.GetStoreRequest}
 */
proto.trendhim.service.stores.GetStoreRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.trendhim.service.stores.GetStoreRequest;
  return proto.trendhim.service.stores.GetStoreRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.trendhim.service.stores.GetStoreRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.trendhim.service.stores.GetStoreRequest}
 */
proto.trendhim.service.stores.GetStoreRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.trendhim.service.stores.GetStoreRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.trendhim.service.stores.GetStoreRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.trendhim.service.stores.GetStoreRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.trendhim.service.stores.GetStoreRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.trendhim.service.stores.GetStoreRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.trendhim.service.stores.GetStoreRequest} returns this
 */
proto.trendhim.service.stores.GetStoreRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.trendhim.service.stores);
